import moment from 'moment';
import actions from './deliveryNoteActions';
import mutations from './deliveryNoteMutations';

const state = {
  items: [],
  filter: {
    date: moment(),
    customerId: null
  }
};

export default {
  namespaced: true,
  state,
  mutations: mutations,
  actions: actions
}



// WEBPACK FOOTER //
// ./client/store/modules/deliveryNote/index.js